export default {
    MapboxToken: process.env.REACT_APP_MAPBOX_TOKEN ?? '',
    SsoConfig: process.env.REACT_APP_SSO_AUTHORITY ? {
        Authority: process.env.REACT_APP_SSO_AUTHORITY!,
        ClientId: process.env.REACT_APP_SSO_CLIENT_ID!,
        RedirectUri: process.env.REACT_APP_SSO_REDIRECT_URI!,
        LogoutRedirectUri: process.env.REACT_APP_SSO_LOGOUT_REDIRECT,
        Scope: process.env.REACT_APP_SSO_SCOPE!,
    } : null,
    CampaignVisualisationActive: process.env.REACT_APP_CAMPAIGN_VISUAL_ACTIVE,
}